import { render, staticRenderFns } from "./DBackToStudioWorkspaceBtn.vue?vue&type=template&id=de2dfd1e&"
import script from "./DBackToStudioWorkspaceBtn.vue?vue&type=script&lang=js&"
export * from "./DBackToStudioWorkspaceBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports